module.exports = __webpack_public_path__ + "img/circle-arrow-down-right.8990db18.svg";